import React, { useMemo, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Button, Form, message, Modal, Select, Space, Typography } from "antd";

import axiosInstance, { endpoints } from "../../services/axios";
import { BooleanReturnType } from "../../hooks/use-boolean";
import { debounce, get } from "lodash";
import { useSearchParams } from "react-router-dom";

const AddEditManagerDialog = ({ modalBool, refetch }: { modalBool: BooleanReturnType; refetch: any }) => {
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { data: users, isFetching: userFetching } = useQuery({
    queryKey: ["schedule-usesr", search],
    queryFn: async () => {
      axiosInstance.defaults.headers.common.Authorization = token;
      return await axiosInstance.get(endpoints.manager.search(search ? "?search=" + search : ""));
    },
    enabled: !!search,
  });

  const usersList = useMemo(() => get(users, "data.data", []).map((item: any) => ({ value: item.id, key: item.id, disabled: !item.enabled, label: `${item.name || ""} ${item.lastName || ""}` })), [users]);

  const { mutate: createManager, isPending } = useMutation({
    mutationFn: async (userId: string) => await axiosInstance.post(endpoints.manager.add(userId), {}),
    onSuccess: () => {
      message.success("Successfully created!");
      cancel();
    },
  });

  const onFinish = useCallback(
    ({ userId }: any) => {
      createManager(userId);
    },
    [createManager]
  );

  const cancel = () => {
    modalBool.onFalse();
    form.resetFields();
    refetch();
  };

  return (
    <Modal
      open={modalBool.value}
      title={
        <Typography.Title className="m-0" level={5}>
          Create new manager
        </Typography.Title>
      }
      closable={false}
      footer={null}
    >
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Form.Item name={"userId"} label="User" rules={[{ required: true, message: "Please enter user!" }]}>
          <Select options={usersList} onSearch={debounce(setSearch, 400)} loading={userFetching} showSearch placeholder="Search users..." defaultActiveFirstOption={false} filterOption={false} notFoundContent={null} />
        </Form.Item>

        <Form.Item className="flex justify-end mb-0">
          <Space>
            <Button onClick={cancel}>Cancel</Button>
            <Button loading={isPending} type="primary" htmlType="submit">
              Add
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditManagerDialog;
